<template>
  <v-list-item>
    <v-list-item-title>
      <div class="flex-container">
        <div>
          <v-icon size="22px" color="transparent">{{ icon }}</v-icon>
          {{ item.name }}
        </div>
        <div v-if="item.type === 'boolean'" class="checkbox-container flex-item-end">
          <input v-model="value" type="checkbox" :disabled="!item.writable" />
        </div>
        <input
          v-else
          v-model.lazy="value"
          :class="['context-input flex-item-end', { 'hide-input': item.type === 'void' }]"
          :disabled="!item.writable"
          @keydown.esc="restoreValue"
        />
      </div> </v-list-item-title
  ></v-list-item>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { isNumber, SimulationContext, Slot } from "../Editor/services/simulation/simulation-control";

const compProps = defineProps<{ item: Slot; icon: string }>();
const emit = defineEmits(["valueChanged"]);

const value = computed({
  get() {
    return compProps.item.value;
  },
  set(newValue) {
    if (isNumber(compProps.item) && Number.isFinite(+newValue)) {
      emit("valueChanged", { fqName: compProps.item.fqName, value: newValue });
    } else if (!isNumber(compProps.item)) {
      emit("valueChanged", { fqName: compProps.item.fqName, value: newValue });
    }
  },
});

function restoreValue(event: KeyboardEvent) {
  const input = event.target as HTMLInputElement;
  input.value = String(compProps.item.value ?? "");
  input.blur();
}
</script>
<style>
.v-treeview-node__prepend {
  width: 100% !important;
}

.hide-input {
  display: none;
}
</style>
